import Account, { IAccountState } from '@store/modules/ui/user/account/accountIndex';
import Bonuses from '@store/modules/ui/user/bonuses/bonusIndex';
import { BonusState } from '@store/modules/ui/user/bonuses/types';
import History, { IHistoryState } from '@store/modules/ui/user/history/historyIndex';
import Messages from '@store/modules/ui/user/messages/messagesIndex';
import Notifications, { INotificationsState } from '@store/modules/ui/user/notifications/notificationsIndex';
import Preferences, {
    IPreferencesState,
    PreferencesGetters,
} from '@store/modules/ui/user/preferences/preferencesIndex';
import Promotions from '@store/modules/ui/user/promotions/promotionIndex';

export interface IUserState {
    histories: IHistoryState;
    bonuses: BonusState;
    account: IAccountState;
    notifications: INotificationsState;
    preferences: IPreferencesState;
}

export interface UIUserGetters {
    preferences: PreferencesGetters;
}

export default {
    namespaced: true,
    modules: {
        history: History,
        account: Account,
        bonuses: Bonuses,
        notifications: Notifications,
        messages: Messages,
        preferences: Preferences,
        promotions: Promotions,
    },
};
